module.exports = __webpack_public_path__ + "img/clzg.6f4fcbce.png";